import { Store } from '../../../../helpers';
import { heatmapLegend } from '../../../../shared/constants';
import { THeatmapTypes } from '../types/heatmap.types';

const numberFormat = (value: number, type: THeatmapTypes) => {
  const opt = {
    currency: 'BRL',
    style: type === 'price' ? 'currency' : 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  } as Intl.NumberFormatOptions;
  return new Intl.NumberFormat('pt-BR', opt).format(value);
};

const betweenLabel = ([min, max]: number[], type: THeatmapTypes) => {
  return `Entre ${numberFormat(min, type)} e ${numberFormat(max, type)}`;
};

const colorLegendMapping: Record<
  string,
  (minMax: number[], type: THeatmapTypes) => string
> = {
  [`${heatmapLegend[0]}`]: ([min, max], type) => {
    return `Acima de ${numberFormat(min, type)}`;
  },
  [`${heatmapLegend[1]}`]: betweenLabel,
  [`${heatmapLegend[2]}`]: betweenLabel,
  [`${heatmapLegend[3]}`]: betweenLabel,
  [`${heatmapLegend[4]}`]: ([min, max], type) =>
    `Menor que ${numberFormat(max, type)}`,
};

export const buildMinMaxLegend = (
  type: THeatmapTypes,
  isPrimaryMarket: boolean
) => {
  const market = isPrimaryMarket ? 'primaryMarket' : 'secondaryMarket';
  const { maxPrice, maxOffers } = Store.getState().heatmap[market];
  const max = type === 'price' ? maxPrice : maxOffers;
  let min = 0;
  const step = (max - min) / heatmapLegend.length;
  const legend = [...heatmapLegend].reverse().map((color) => {
    const labelMin = min;
    min += step;
    return {
      color,
      range: [labelMin, labelMin + step],
    };
  });
  return legend;
};

export const buildHeatmapLegend = (color: string, isPrimaryMarket: boolean) => {
  const { type } = Store.getState().heatmap;
  const currentLegend = buildMinMaxLegend(type, isPrimaryMarket).find(
    (legend) => legend.color === color
  );
  if (currentLegend) {
    return colorLegendMapping[color](currentLegend.range, type);
  }
  return '';
};
